/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Csv_To_Json_Body2Inputs */

const en_csv_to_json_body2 = /** @type {(inputs: Csv_To_Json_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doubled double quotes inside a quoted field are read as one literal quote, blank lines are skipped rather than becoming rows of empty strings, and a record with fewer fields than the header gets empty strings for the remainder. What the parser deliberately does not do is guess types, which is the subject of the section below.`)
};

const ko_csv_to_json_body2 = /** @type {(inputs: Csv_To_Json_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`인용 필드 안의 두 개짜리 큰따옴표는 리터럴 따옴표 하나로 읽히고, 빈 줄은 빈 문자열 행이 되지 않고 건너뛰어지며, 헤더보다 필드가 적은 레코드는 나머지에 빈 문자열을 받습니다. 이 파서가 의도적으로 하지 않는 일은 타입 추측이며, 아래 절의 주제입니다.`)
};

const ja_csv_to_json_body2 = /** @type {(inputs: Csv_To_Json_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`引用フィールド内の 2 つ続いた二重引用符はリテラルの引用符 1 つとして読まれ、空行は空文字列の行にならず飛ばされ、ヘッダよりフィールドが少ないレコードは残りに空文字列を受け取ります。このパーサが意図的にやらないのは型の推測で、それが次の節の主題です。`)
};

/**
* | output |
* | --- |
* | "Doubled double quotes inside a quoted field are read as one literal quote, blank lines are skipped rather than becoming rows of empty strings, and a record w..." |
*
* @param {Csv_To_Json_Body2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const csv_to_json_body2 = /** @type {((inputs?: Csv_To_Json_Body2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_To_Json_Body2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_csv_to_json_body2(inputs)
	if (locale === "ko") return ko_csv_to_json_body2(inputs)
	return ja_csv_to_json_body2(inputs)
});